import { instance } from "libs/api";

import { ApiRoutesMarketing } from "../../constants";
import { LaunchMarketingCampaignResponse } from "../../marketing.types";

export const requestLaunchMarketingCampaign = async (
  campaignId: string
): Promise<LaunchMarketingCampaignResponse> => {
  return await instance.post(
    `${ApiRoutesMarketing.Campaigns}/${campaignId}/launch`
  );
};
